export default {
      id: "arcs_paragraphe-usage",
      viewBox: "0 0 110 110",
      url: "../dist/images/" + "sprite.svg#arcs_paragraphe-usage",
      toString: function () {
        return this.url;
      }
    }